/**
 * Section 2: Property Access
 */

import { useCallback } from 'preact/hooks';
import { useForm } from '@ox/visits-ui/context/FormContext';
import { Input, Select } from '@ox/visits-ui/components/shared/FormComponents';

export function Section10ComparableGate() {
  const { formData, updateField } = useForm();

  const handleCompMethodChange = useCallback(
    (value: string) => updateField('comp_method', value),
    [updateField],
  );

  const handleMarketAdvisorIdChange = useCallback(
    (value: string) => updateField('market_advisor_id', value),
    [updateField],
  );

  return (
    <div className="form-section">
      <h2>Comparables</h2>

      <Select
        label="How are you providing comps?"
        name="comp_method"
        value={formData.comp_method || ''}
        onChange={handleCompMethodChange}
        options={[
          { label: 'Select...', value: '', disabled: true },
          { label: 'Market Advisor', value: 'market' },
          { label: 'Manual Comps', value: 'manual' },
        ]}
        required
      />
      {
        formData.comp_method === 'market' && (
          <Input
            label="Market Advisor Valuation ID"
            name="market_advisor_id"
            value={formData.market_advisor_id || ''}
            onChange={handleMarketAdvisorIdChange}
            placeholder="Enter access codes"
          />
        )
      }
    </div>
  );
}
